<template>
  <section class="clients_container">
    <section    v-if="isClientsDataLoaded" class="clients_content_container">
      <article
     
        v-for="(client, index) in clientsData"
        :key="index"
        class="clientBox_article wow fadeInUp"
      >
        <div class="images_container">
          <ImageLoader
            v-if="client.companyLogo"
            :errorImageSrc="getImgUrl('codeclinic_logo.png')"
            :imageSrc="client.companyLogo"
            :alt="client.city"
            class="company_logo"
          >
          <Loader/>
          </ImageLoader>
          <ImageLoader
            v-if="client.buyerLogo"
            :errorImageSrc="getImgUrl('codeclinic_logo.png')"
            :imageSrc="client.buyerLogo"
            :alt="client.buyerName"
          >
          <Loader/>
          </ImageLoader>
          <ImageLoader
            v-else
            :errorImageSrc="getImgUrl('codeclinic_logo.png')"
            :imageSrc="getImgUrl('codeclinic_logo.png')"
            :alt="client.buyerName + 'ss'"
          >
            <Loader/>
          </ImageLoader>

        </div>
        <p class="buyerName" dir="auto">{{ client.buyerName }}</p>
        <p class="programName">{{ client.programName }}</p>
        <div class="card_footer">
          <span>{{ client.city || "" }}</span>
          <i class="fas fa-map-marker-alt" />
        </div>
      </article>
      
    </section>
    <article v-else  class="clients_content_container">
        <Loader />
      </article>
    <WaveFooter />
  </section>
</template>

<script>
import ImageLoader from "@/components/ImageLoader.vue";
import WaveFooter from "@/components/WavFooter";
import Loader from "@/components/Loader.vue";
import { getImgUrl } from "@/util/methods";
export default {
  name: "Clients",
  components: {
    WaveFooter,ImageLoader,Loader
  },
  computed: {
    clientsData() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].clients;
    }, isClientsDataLoaded() {
      const { lang } = this.$store.state;
      console.log(this.$store.state[lang].isClientsDataLoad)
      return this.$store.state[lang].isClientsDataLoad;
    },
  },
  methods: {
    getImgUrl,
  },
};
</script>

<style></style>
